import { ClientMajorErrorTypes } from './types/ClientMajorErrorTypes'

/**
 * This error means some not-critical, but major error with some of blocks
 *
 * Example of major error: Not valid zod validation on reservation form
 * before submit of form
 *
 * This means we just forget add some validation to HTML or some plugin
 * change our validation and we catch error with not valid data on check
 * before send it to server
 */
export class ClientMajorError extends Error {
	type: ClientMajorErrorTypes

	constructor(type: ClientMajorErrorTypes, message: string) {
		super(message)
		this.type = type
	}
}
